import { compose } from 'recompose';

import UserCreate from './UserCreate';

const enhance = compose();

export default enhance(UserCreate);
